<div class="coupon-item" provide-parent-form>
    <div class="row" style="justify-content: space-between;">
        <label for="text">{{'COUPON.PRIZE' | translate}} #{{(index+1).toString()}}</label>
        <button class="link-button" (click)="toggleLink()" pTooltip="{{'COUPON.LINK_TOOLTIP' | translate }}" tooltipPosition="top"
>
            <img [hidden]="displayLink" src="assets/images/icons/Icon feather-link.svg" />
            <img [hidden]="!displayLink" src="assets/images/icons/Icon feather-link green.svg" />

        </button>
    </div>

    <input style="margin-top:16px;" [hidden]="!displayLink" type="text" class="input-link" name="redirectLink{{index}}"
        placeholder="{{'COUPON.LINK_TO_THE_AWARS' | translate}}" [(ngModel)]="coupon.RedirectLink" (input)="onLinkInput()">
    <div *ngIf="coupon.RedirectLink?!isValidHttpUrl(coupon.RedirectLink):false">{{'ERRORS.INVALID_URL' | translate}}
    </div>

    <!--  [(ngModel)]="coupon.RedirectLink" urlValidator>
        <div *ngIf="coupon.RedirectLink?!(form.controls['redirectLink'+index]?.valid && form.controls['redirectLink'+index]?.errors?.urlValidation) :false"></div>
<div>{{ !form.controls['redirectLink'+index]?.errors?.urlValidation }} </div> -->


    <div class="row icon-name-wrapper" style="margin-top:16px;">
        <button class="icon-button" (click)="op.toggle($event)">
            <img [src]="coupon.IconUrl" alt="Image" />
            <span>{{'COUPON.ICONֹֹ_CHANGE' | translate}}</span>
        </button>
        <!-- <div class="r-form-group cupon-text">
            <textarea rows="2" name="text{{index}}" #text{{index}}="ngModel" [(ngModel)]="coupon.Text"
                [maxlength]="coponTextMaxLength" required></textarea>
            <span class="text-length">{{coupon.Text.length}}/{{coponTextMaxLength}}</span>
            <div *ngIf="!form.controls['text'+index]?.valid && form.controls['text'+index]?.errors?.required"
                class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
            <div *ngIf="!form.controls['text'+index]?.valid && form.controls['text'+index]?.errors?.maxlength"
                class="error-required"> {{'ERRORS.MAX_LENGTH' | translate}} {{coponTextMaxLength}}
            </div>
        </div> -->
        <!-- <div class=""> -->
            <div class="r-form-group cupon-text">
                <textarea rows="2" name="text{{index}}" #text{{index}}="ngModel" [(ngModel)]="coupon.Text"
                    [maxlength]="coponTextMaxLength" required [placeholder]="'COUPON.TEXT1' |translate"></textarea>
                <span class="text-length">{{coupon.Text.length}}/{{coponTextMaxLength}}</span>
                <div *ngIf="!form.controls['text'+index]?.valid && form.controls['text'+index]?.errors?.required"
                    class="error-required">
                    {{'ERRORS.REQUIRED' | translate}}
                </div>
            </div>

            <div class="r-form-group cupon-text">
                <textarea rows="2" name="text1{{index}}" #text1{{index}}="ngModel" [(ngModel)]="coupon.Text1"
                    [maxlength]="coponTextMaxLength2"  [placeholder]="'COUPON.TEXT2' |translate"></textarea>
                <span class="text-length">{{coupon.Text1?.length ||0 }}/{{coponTextMaxLength2}}</span>
            </div>

            <div class="r-form-group cupon-text">
                <textarea rows="2" name="text2{{index}}" #text2{{index}}="ngModel" [(ngModel)]="coupon.Text2"
                    [maxlength]="coponTextMaxLength3"  [placeholder]="'COUPON.TEXT3' |translate"></textarea>
                <span class="text-length">{{coupon.Text2?.length||0}}/{{coponTextMaxLength3}}</span>
            </div>
        <!-- </div> -->
    </div>
    <!--  why panel for each item -->
    <p-overlayPanel #op [showCloseIcon]="true" [style]="{width:'426px', height:'400px'}" appendTo="body">
        <ng-template pTemplate>
            <div class="panel-header">{{'COUPON.ICONֹֹ_SELECTION' | translate}} </div>
            <div class="row  icon-buttons-container">
                <button *ngFor="let icon of iconsList" class="icon-button select"
                    [ngClass]="{'selected-icon': coupon.IconId===icon.Id}" (click)="changeCouponIcon(coupon,icon)">
                    <img [src]="icon.Url " alt="Image" />
                </button>
            </div>
        </ng-template>
    </p-overlayPanel>
</div>